import Dialog from "@components/Dialog/Dialog";
import { useAppSelector } from "@utils/reduxUtil";
import styles from "./AppDialogStyles";
import useStyles from "@hooks/useStyle";

export const AppDialog = () => {
	// const dispatch = useAppDispatch();
	const { dialog } = useAppSelector((state) => ({
		dialog: state.common.dialog,
	}));

	const { classes } = useStyles(styles) as any;

	if (!dialog.open) return null;
	return (
		<Dialog className={classes.appDialog} title={dialog.config?.title}>
			{dialog.config?.content}
		</Dialog>
	);
};
